import { doc, deleteDoc, setDoc } from "../db/firebase.js";
import { reviewsCollection } from "../db/firebase.js";

// Функция создания карточки отзыва
export function createReviewCard(
  data,
  id,
  isAdmin,
  openFormModal,
  showConfirm,
) {
  const card = document.createElement("div");
  card.className =
    "bg-slate-50 p-6 rounded-lg border border-slate-200 relative";

  let adminButtons = "";

  if (isAdmin) {
    if (data.approved) {
      // Approved review → normal edit/delete
      adminButtons = `
        <div class="absolute top-2 right-2 flex gap-2">
          <button class="edit-review-btn bg-orange-400 text-white w-8 h-8 rounded-full flex items-center justify-center shadow-md hover:bg-orange-500" data-id="${id}">
            <i data-lucide="pencil" class="w-4 h-4"></i>
          </button>
          <button class="delete-review-btn bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center shadow-md hover:bg-red-600" data-id="${id}">
            <i data-lucide="trash-2" class="w-4 h-4"></i>
          </button>
        </div>
      `;
    } else {
      // Unapproved review → approve / decline buttons
      adminButtons = `
        <div class="absolute top-2 right-2 flex gap-2">
          <button class="approve-review-btn bg-green-500 text-white w-8 h-8 rounded-full flex items-center justify-center shadow-md hover:bg-green-600" data-id="${id}">
            <i data-lucide="check" class="w-4 h-4"></i>
          </button>
          <button class="decline-review-btn bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center shadow-md hover:bg-red-600" data-id="${id}">
            <i data-lucide="x" class="w-4 h-4"></i>
          </button>
        </div>
      `;
    }
  }

  // card.innerHTML = `
  //   ${adminButtons}
  //   <h4 class="font-semibold text-orange-900 mb-2">${data.name || "Аноним"}</h4>
  //   <p class="text-slate-700 text-base">${data.text || ""}</p>
  // `;
  card.innerHTML = `
    ${adminButtons}
    <h4 class="font-semibold text-orange-900 mb-2">${data.name}</h4>
    <p class="text-slate-700 text-base">${data.text}</p>
  `;

  // Edit
  const editBtn = card.querySelector(".edit-review-btn");
  if (editBtn) {
    editBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      openFormModal("review", data, id);
    });
  }

  // Delete
  const deleteBtn = card.querySelector(".delete-review-btn");
  if (deleteBtn) {
    deleteBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      showConfirm(
        "Удалить отзыв?",
        `Вы уверены, что хотите удалить отзыв от "${data.name}"?`,
        async () => {
          try {
            await deleteDoc(doc(reviewsCollection, id));
            console.log(`Отзыв ${id} удален.`);
          } catch (error) {
            console.error("Ошибка удаления отзыва:", error);
          }
        },
      );
    });
  }

  // Approve
  const approveBtn = card.querySelector(".approve-review-btn");
  if (approveBtn) {
    approveBtn.addEventListener("click", async (e) => {
      e.stopPropagation();
      try {
        await setDoc(
          doc(reviewsCollection, id),
          { approved: true },
          { merge: true },
        );
        console.log(`Отзыв ${id} одобрен.`);
      } catch (error) {
        console.error("Ошибка одобрения отзыва:", error);
      }
    });
  }

  // Decline
  const declineBtn = card.querySelector(".decline-review-btn");
  if (declineBtn) {
    declineBtn.addEventListener("click", async (e) => {
      e.stopPropagation();
      showConfirm(
        "Отклонить отзыв?",
        `Вы уверены, что хотите отклонить отзыв от "${data.name}"?`,
        async () => {
          try {
            await deleteDoc(doc(reviewsCollection, id));
            console.log(`Отзыв ${id} отклонен и удален.`);
          } catch (error) {
            console.error("Ошибка отклонения отзыва:", error);
          }
        },
      );
    });
  }

  return card;
}
